import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { UserService } from './user.service';
import { LeapmotorUserTokenDTO } from '../models/user-dto';

@Injectable({
  providedIn: 'root'
})

export class AuthJwtService {

  private pathAPI = environment.urlAPI;
  private authenticationChanged = new Subject<boolean>();

  constructor(private http: HttpClient,
    private userService: UserService) {
  }

  public loginOTP(body: any): Observable<any> {
    let urlToken = this.pathAPI + 'Login/LoginOTP';
    return this.http.post<any>(urlToken, body);
  }

  public loginPassword(body: any): Observable<any> {
    let urlToken = this.pathAPI + 'Login/LoginPassword';
    return this.http.post<any>(urlToken, body);
  }

  public sendCode(body: any): Observable<any> {
    let urlToken = this.pathAPI + 'Login/SendMailCodeOTP';
    return this.http.post<any>(urlToken, body).pipe(
      tap(async (res: any) => {
        
      })
    );
  }

  public refreshToken(body: any): Observable<any> {

    let urlToken = this.pathAPI + 'Login/Refresh';
    return this.http.post<any>(urlToken, body).pipe(
      tap(async (res: any) => {
        if (res.tokenLeapmotor.length > 0) {
          this.setStorageToken(res.tokenLeapmotor);
          this.setStorageRefreshToken(res.refreshTokenLeapmotor);
        }
      })
    );
  }

  public logout(): void {
    this.setStorageToken(undefined);
    this.setStorageRefreshToken(undefined);
    this.userService.setUserData(null);
  }

  public setToken(data: any): void {
    this.setStorageToken(data.tokenLeapmotor);
    this.setStorageRefreshToken(data.refreshTokenLeapmotor);
  }

  public setStorageToken(value: any): void {
    window.localStorage['tokenLeapmotor'] = value;
    this.authenticationChanged.next(this.isAuthenticated());
  }

  public setStorageRefreshToken(value: any): void {
    window.localStorage['refreshTokenLeapmotor'] = value;
  }

  public isAuthenticated(): boolean {

    return (!(window.localStorage['tokenLeapmotor'] === undefined ||
      window.localStorage['tokenLeapmotor'] === null ||
      window.localStorage['tokenLeapmotor'] === 'null' ||
      window.localStorage['tokenLeapmotor'] === 'undefined' ||
      window.localStorage['tokenLeapmotor'] === ''));
  }

  public isAuthenticationChanged(): any {
    return this.authenticationChanged.asObservable();
  }

  public getToken(): any {
    if (window.localStorage['tokenLeapmotor'] === undefined ||
      window.localStorage['tokenLeapmotor'] === null ||
      window.localStorage['tokenLeapmotor'] === 'null' ||
      window.localStorage['tokenLeapmotor'] === 'undefined' ||
      window.localStorage['tokenLeapmotor'] === '') {
      return '';
    }
    let obj = window.localStorage['tokenLeapmotor'];
    return obj;
  }

  public getRefreshToken(): any {
    if (window.localStorage['refreshTokenLeapmotor'] === undefined ||
      window.localStorage['refreshTokenLeapmotor'] === null ||
      window.localStorage['refreshTokenLeapmotor'] === 'null' ||
      window.localStorage['refreshTokenLeapmotor'] === 'undefined' ||
      window.localStorage['refreshTokenLeapmotor'] === '') {
      return '';
    }
    let obj = window.localStorage['refreshTokenLeapmotor'];
    return obj;
  }

  public getUserDataManual(token): LeapmotorUserTokenDTO {
    if (token == null || token.trim() == '') return null;
    let jwt = JSON.stringify(token);
    return this.getTokenModel(jwt);
  }

  private getTokenModel(jwt): LeapmotorUserTokenDTO {
    if (jwt == null || jwt.trim() == '' || jwt.trim() == "") return null;
    let jwtData = jwt.split('.')[1]    
    let decodedJwtJsonData = this.b64DecodeUnicode(window.atob(jwtData));    
    let decodedJwtData = JSON.parse(decodedJwtJsonData);
    let userData = JSON.parse(decodedJwtData.UserData);    
    return userData;
  }

  private b64DecodeUnicode(str) {
    return decodeURIComponent(str.split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }

}
